import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import PageConstructor from './PageConstructor/PageConstructor';
import SelectPageType from './SelectPageType/SelectPageType';

export default function CreatePaymentPage() {
    const [activePanel, setActivePanel] = React.useState('pageType');
    const [isRecurrent, setIsRecurrent] = React.useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    function handlePageTypeSelect(recurrent) {
        if (recurrent) {
            window.ym(91769012, 'reachGoal', 'create_subscription');
        } else {
            window.ym(91769012, 'reachGoal', 'create_single_payment');
        }
        setIsRecurrent(recurrent);
        setActivePanel('pageConstructor');
    }

    function handleTypeBack() {
        navigate('/pages', { state: location.state });
    }

    function handleConstructorBack() {
        setActivePanel('pageType');
    }

    if (activePanel === 'pageType') {
        return <SelectPageType onBackClick={handleTypeBack} onSelect={handlePageTypeSelect} />;
    }

    return <PageConstructor data={{ is_recurrent: isRecurrent }} onBackClick={handleConstructorBack} />;
};
